module.exports = __webpack_public_path__ + "static/img/cstSer_bg_white_03.1293ef70.svg";